import React from "react";
import PropTypes from "prop-types";
import { Button, ModalFooter } from "reactstrap";

const propTypes = {
  reviewResults: PropTypes.shape({
    impressions: PropTypes.number.isRequired,
    clicks: PropTypes.number.isRequired,
    bonus_impressions: PropTypes.number.isRequired,
    ctr_higher_pct: PropTypes.number.isRequired
  }).isRequired,
  onContinue: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired
};

const ReviewResultsStep = ({ reviewResults, onContinue, onKeep }) => {
  const {
    impressions,
    clicks,
    bonus_impressions: bonusImpressions,
    ctr_higher_pct: ctrHigher
  } = reviewResults;

  return (
    <div>
      <p className="text-center text-muted mb-3">
        Next, let&apos;s quickly review your results so far.
      </p>

      <div className="text-center mb-3">
        <p className="mb-1">
          Your ad has been seen <strong>{impressions.toLocaleString()} times</strong> by people who
          live or work in your zip codes.
        </p>
        {bonusImpressions > 0 && (
          <p className="text-success mb-1">
            That&apos;s <strong>{bonusImpressions.toLocaleString()} bonus ad views</strong> we
            delivered at no additional cost.
          </p>
        )}
        {clicks > 0 && (
          <>
            <p className="mb-1">
              Your ad has been clicked <strong>{clicks.toLocaleString()} times</strong>.
            </p>
            {ctrHigher > 0 && (
              <p className="text-success mb-1">
                That&apos;s <strong>{ctrHigher}% higher</strong> than industry average!
              </p>
            )}
          </>
        )}
      </div>

      <p className="text-center text-muted mb-0">
        Are you sure you wish to stop advertising to potential clients in your zip codes?
      </p>

      <ModalFooter className="pt-2 px-0">
        <Button color="secondary" className="btn-sharp" onClick={onContinue}>
          Stop Advertising
        </Button>
        <Button color="primary" className="btn-sharp" onClick={onKeep}>
          Keep Advertising
        </Button>
      </ModalFooter>
    </div>
  );
};

ReviewResultsStep.propTypes = propTypes;

export default ReviewResultsStep;
